<div *ngIf="currentInteraction && scenario" class="scenarioWrapper">
  <amc-scenario [scenario]="scenario" (newMessage)="newMessage($event, scenario)"></amc-scenario>
</div>
